<template>
  <div class="page-wrap">
    <v-alert v-if="error" type="error" dense outlined>{{ error }}</v-alert>
    <v-card class="pa-4 mb-4">
      <div class="d-flex align-center mb-2">
        <h1 class="text-h5 font-weight-bold mr-2">Operaciones y Salud</h1>
        <HelpHint text="Vista operativa para validar disponibilidad del backend y métricas de uso por endpoint." />
      </div>
      <v-btn color="primary" @click="refreshAll">Actualizar</v-btn>
      <div class="mt-3 body-2">Estado API: <strong>{{ healthStatus }}</strong></div>
    </v-card>

    <v-card>
      <v-data-table :headers="headers" :items="metrics" :loading="loading" dense />
    </v-card>
  </div>
</template>

<script>
import HelpHint from "@/components/HelpHint.vue";
import { accountingService } from "@/services/accounting";

export default {
  name: "OpsMonitoringView",
  components: { HelpHint },
  data() {
    return {
      loading: false,
      error: "",
      healthStatus: "unknown",
      metrics: [],
      headers: [
        { text: "Ruta", value: "route" },
        { text: "Requests", value: "count" },
        { text: "Errores", value: "errors" },
        { text: "Latencia Prom (ms)", value: "avgMs" },
      ],
    };
  },
  mounted() {
    this.refreshAll();
  },
  methods: {
    parseError(err) {
      return err?.response?.data?.error || err?.response?.data?.message || err?.message || "Error inesperado";
    },
    async refreshAll() {
      this.loading = true;
      this.error = "";
      try {
        const [h, m] = await Promise.all([
          accountingService.getOpsHealth(),
          accountingService.getOpsMetrics(),
        ]);
        this.healthStatus = h?.data?.data?.status || "down";
        this.metrics = Array.isArray(m?.data?.data) ? m.data.data : [];
      } catch (err) {
        this.error = this.parseError(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.page-wrap { display: flex; flex-direction: column; gap: 12px; }
</style>
